import { jsx } from "react/jsx-runtime";
import React, { useState, useCallback, useEffect, useContext } from "react";
const initialState = Date.now();
const Context = React.createContext(initialState);
const mockedTimerProviderValue = 1679320162062;
let timeout;
const TimerProvider = ({ children, disabled }) => {
  const [duration, setDuration] = useState(disabled ? mockedTimerProviderValue : initialState);
  const timer = useCallback(() => {
    timeout = setTimeout(() => {
      if (!disabled) {
        setDuration(Date.now());
        timer();
      }
    }, 1e3);
  }, []);
  useEffect(() => {
    clearInterval(timeout);
    timer();
    return () => clearInterval(timeout);
  }, []);
  return /* @__PURE__ */ jsx(Context.Provider, { value: duration, children });
};
const useTimerProvider = (disabled) => {
  const context = useContext(Context);
  if (disabled)
    return Date.now();
  if (context === void 0) {
    throw new Error("useTimerProvider must be used within TimerProvider.");
  }
  return context;
};
export {
  Context,
  TimerProvider,
  mockedTimerProviderValue,
  useTimerProvider
};
